import { render } from "./VacanciesSection.vue?vue&type=template&id=13f05ed3"
import script from "./VacanciesSection.vue?vue&type=script&lang=js"
export * from "./VacanciesSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__